import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { enableCompany, getAllCompanies } from "../../network/api/company";
import { FiSearch } from "react-icons/fi";
import { IoMdSend } from "react-icons/io";

const ViewCompaniesPage = (props) => {
  const cookie = new Cookies();

  const [companies, setCompanies] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [role, setRole] = useState(cookie.get("role"));
  const [searchValue, setSearchValue] = useState("");

  const [currentPage, setCurrentPage] = useState(
    Number(cookie.get("companies_page")) || 1,
  );

  const companiesGet = async () => {
    setCompanies(null);

    const result = await getAllCompanies(currentPage, searchValue);

    setCompanies(result.data.companies);
    setPageCount(result.data.pageCount);
    setTotalCount(result.data.totalCount);
  };

  useEffect(() => {
    companiesGet();
  }, [currentPage]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("companies_page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      cookie.set("companies_page", currentPage - 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      cookie.set("companies_page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleEnable = (id, enable) => {
    enableCompany(id, enable).then((result) => {
      if (result.data.message === "Done") {
        if (enable) {
          toast.success("Company is disabled", {
            position: "top-right",
          });
        } else {
          toast.success("Company is enabled", {
            position: "top-right",
          });
        }
        setCompanies((prev) =>
          prev.map((company) =>
            company._id === id
              ? { ...company, enable: !company.enable }
              : company,
          ),
        );
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    });
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePageClick(1);
    companiesGet();
  };

  return (
    <>
      {companies === null ? (
        <LoadingPage />
      ) : (
        <div className="channel-page">
          {/* HEADER */}
          <form onSubmit={handleSubmit}>
            <div className="search-input-wrapper">
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder={`Search by name`}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                className="search-input"
              />
              <button
                type="submit"
                style={{
                  background: "none",
                  border: "none",
                  color: "#2980b9",
                  fontSize: "20px",
                  display: "flex",
                  marginLeft: "10px",
                }}
              >
                <IoMdSend />
              </button>
            </div>
          </form>
          <div className="page-header">
            <h2>{props.role}</h2>
            <span>
              {totalCount || 0} {props.role}
            </span>
          </div>

          {/* DESKTOP TABLE */}
          <div className="table-scroll">
            <div className="table-container">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Established At</th>
                    <th>Address</th>
                    <th>Commercial Registration</th>
                    <th>Tax Number</th>
                    <th>Enable</th>
                  </tr>
                </thead>

                <tbody>
                  {companies?.map((item) => (
                    <tr key={item._id}>
                      <td>{item.name}</td>
                      <td>{item.email}</td>
                      <td>{item.estableshedAt}</td>
                      <td>{item.address}</td>
                      <td>{item.commercialRegestration}</td>
                      <td>{item.taxNumber}</td>
                      {item.super ? (
                        <td>Super</td>
                      ) : (
                        <td>
                          <button
                            className="assignbtn"
                            onClick={() => {
                              handleEnable(item._id, !item.enable);
                            }}
                          >
                            {item.enable ? "Disable" : "Enable"}
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* MOBILE CARDS */}
          <div className="cards-container">
            {companies?.map((item) => (
              <div className="channel-card" key={item._id}>
                <div className="card-title">{item.name}</div>
                <div className="card-date">
                  {new Date(item.createdAt).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {currentPage !== 1 && (
              <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className="paginationButton"
              >
                Previous
              </button>
            )}
            {renderPageNumbers()}
            {currentPage !== pageCount && pageCount > 0 && (
              <button
                onClick={handleNext}
                disabled={currentPage === pageCount}
                className="paginationButton"
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default ViewCompaniesPage;
